const intercomBaseAttributes = {
  api_base: 'https://api-iam.intercom.io',
  app_id: process.env.REACT_APP_INTERCOM_ID,
};

export default intercomBaseAttributes;
